import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
import Reel from "./Reel";
export default class ReelStatic extends Reel {
    constructor(x, y, index, cellCreation, expanding) {
        super(x, y, index, cellCreation, expanding);
    }
    configureSpinTween() {
        this.resetFlagsAndCounters();
        this.spinProgress = scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height },
            paused: true,
            loop: -1,
            delay: 0,
            yoyo: false,
            duration: this.spinAnimationDuration,
            onStart: () => {
                // this.expandingWild.getContainer().setVisible(false);
                this.getCells().forEach(cell => {
                    cell.resetLayer();
                    cell.stopAnimation();
                });
                this.turnOn();
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }
                this.getCells().forEach(cell => {
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                    // ON/OFF depending on memo if suspense is on
                    if (this.suspense && this.suspenseStarted) {
                        if (Utils.includes(ResourcesDispatcher.GAME_CONSTANTS.onDuringSuspense, cell.getMemo())) {
                            cell.turnOn();
                        }
                        else {
                            cell.turnOff();
                        }
                    }
                });
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }
                this.virtualReelPosition = (this.virtualReelPosition + 1) % scene.gameArea.virtualGrid[this.index].length;
                scene.gameArea.increaseLoopCounter(this.index);
                this.reIndexCells();
                if (this.mustStop) {
                    this.getCell(0).setCellInfo(gameDataManager.getOutGridCellsUp()[this.index]);
                    this.getCell(this.lastCellIndex).setCellInfo(gameDataManager.getOutGridCellsDown()[this.index]);
                    // Real memo
                    for (let i = 1; i < this.lastCellIndex; i++) {
                        const realmemo = gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (i - 1)];
                        let gridListIndex = Utils.getCellGridIndex(this.index, i, this.numOfCellsPerReel, this.numOfExtraCellsPerReel);
                        this.getCell(i).setCellInfo(realmemo, undefined, gridListIndex ? gameDataManager.getLinkGrid()[gridListIndex] : undefined);
                    }
                    this.spinProgress.stop();
                    this.bounce();
                }
                else if (!this.canStop) { // Fake memo
                    const xmemo = scene.gameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.getCell(this.lastCellIndex).setCellInfo(xmemo);
                }
                else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        this.getCell(this.lastCellIndex).setCellInfo(gameDataManager.getOutGridCellsDown()[this.index]);
                    }
                    else if (this.realMemoIndex < this.lastCellIndex) { // Visible cell, real memo
                        const realmemo = gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)];
                        this.getCell(this.lastCellIndex).setCellInfo(realmemo, undefined, gameDataManager.getLinkGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)] ?? undefined);
                    }
                    else if (this.realMemoIndex === this.lastCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        this.getCell(this.lastCellIndex).setCellInfo(gameDataManager.getOutGridCellsUp()[this.index]);
                        this.spinProgress.stop();
                        this.bounce();
                    }
                    this.realMemoIndex++;
                }
            }
        });
    }
    bounce() {
        if (this.stopped) {
            return;
        }
        this.bounceTween1 = scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75 },
            yoyo: false,
            duration: this.spinAnimationDuration * 0.75,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.getCells().forEach((cell) => {
                    // Position
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onComplete: () => {
                soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);
                if (!gameLogicVariableManager.getTurbo()) {
                    for (let i = 0; i < this.lastCellIndex; i++) {
                        const currentCell = this.getCell(i);
                        if (!currentCell)
                            continue;
                        const memo = currentCell.getMemo();
                        if (ResourcesDispatcher.GAME_CONSTANTS.ANIMATED_SYMBOLS.includes(memo)) {
                            this.playAnimationBounceSingleCell(currentCell, memo);
                        }
                    }
                    // Scatter sound
                    if (gameDataManager.getScatterInfo().length > 0) {
                        const scatter = (gameDataManager.getScatterInfo().filter((info) => info.reelIndex === this.index).length !== 0);
                        const minNumScatter = (gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME ? 2 : 3);
                        const previousReelsWithScatter = gameDataManager.getScatterInfo().filter((info) => info.reelIndex < this.index).length;
                        const residualScattersToWin = minNumScatter - previousReelsWithScatter - (scatter ? 1 : 0); // -1 because this reeel contains a scatter
                        const residualReels = this.numOfReels - 1 - this.index;
                        if ((scatter && !this.mustStop && residualScattersToWin <= 0) || // CONDITION 1: scatter in reel, no forced stop, freegame already won
                            (scatter && !this.mustStop && residualScattersToWin <= residualReels) || // CONDITION 2: scatter in reel, no forced stop, freegame can still be won
                            (this.mustStop && residualReels === 0 && residualScattersToWin === 0) // CONDITION 3: forced stop, last reel and freegame already won
                        ) {
                            //TODO Mettere questa riga e sostituire con this.soundscatterinreel con sound
                            soundManager.getSoundGame().play(this.soundScatterInReel.key, { loop: this.soundScatterInReel.loop, volume: this.soundScatterInReel.volume });
                        }
                    }
                }
                // Turbo on(low volume) or forced stop
                if (gameLogicVariableManager.getTurbo() || this.mustStop) {
                    // TODO: add stop sound
                }
                this.bounceTween2 = scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 6,
                    //TODO implementare ONSTART
                    onStart: () => {
                    },
                    onUpdate: () => {
                        this.getCells().forEach((cell) => {
                            // Position
                            cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                        });
                    },
                    onComplete: () => {
                        this.getCells().forEach((cell) => {
                            cell.checkLayer();
                        });
                        scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                scene.gameArea.notifySpinCompleted(this.index);
                            },
                        });
                        this.manageSuspense();
                    }
                });
            }
        });
    }
}
